import { useState, useEffect } from 'react';
import { useCustomNavigate, useServices } from '@app/hooks';
import {
  ImportFromLibrary,
  IntentDetails,
  IntentDetailsMode
} from '@app/page-components/modals';
import { CommonIntent, DesignIntent } from '@app/types';

export function ImportFromLibraryPage() {
  const {
    intentService,
    loadingService
  } = useServices();
  const navigate = useCustomNavigate();
  const [intent, setIntent] = useState<DesignIntent>();
  const [commonIntents, setCommonIntents] = useState<CommonIntent[]>([]);

  useEffect(() => {
    loadingService.useLoading(async () => {
      setCommonIntents(await intentService.getCommonIntents());
    });
  }, []);

  const onCloseModal = () => {
    navigate('intents/management');
  };

  return (
    intent ? (
      <IntentDetails
        intent={intent}
        mode={IntentDetailsMode.create}
        onComplete={(newIntent) => {
          if (newIntent) {
            window.apm.addNode(newIntent);
            window.apm.setSerializedChanged();
            window.apm.refreshApplicationTree();
          }
          onCloseModal();
        }}
      />
    ) : (
      <ImportFromLibrary
        canSave
        isOpen={true}
        onCancel={onCloseModal}
        onImport={(commonIntent: CommonIntent) => {
          const {
            commonId,
            description,
            droppable,
            name
          } = commonIntent;
          const newIntent = intentService.initializeIntent();

          setIntent({
            ...newIntent,
            name,
            props: {
              ...newIntent.props,
              config: {
                ...newIntent.props.config,
                commonIntent: {
                  description: description ?? '',
                  intentId: commonId,
                  name
                },
                description,
                droppable
              }
            }
          });
        }}
        commonIntents={commonIntents}
      />
    )
  );
}
